import { Card, TextField, Typography, Button, Box } from "@mui/material";
import { Link } from "react-router-dom";

export default function Register() {
  return (
    <Box display="flex" justifyContent="center" mt={10}>
      <Card sx={{ p: 4, width: 400 }}>
        <Typography variant="h4" textAlign="center">
          Create Account
        </Typography>

        <TextField fullWidth label="Full Name" margin="normal" />
        <TextField fullWidth label="Mobile Number" margin="normal" />

        <Button fullWidth variant="contained" sx={{ mt: 2 }}>
          Send OTP
        </Button>

        <Typography mt={2} textAlign="center">
          Already have an account? <Link to="/auth/login">Login</Link>
        </Typography>
      </Card>
    </Box>
  );
}
